module.exports = __webpack_public_path__ + "img/input-dark.687b727e.png";